import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios';
import { Link } from 'react-router-dom'
import Navbar from './Navbar'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import moment from "moment";
import { DatePicker } from 'antd';
import "react-datepicker/dist/react-datepicker.css";
const taxrate = 0.0915;


class CheckOut extends Component {
    constructor(props) {

        super(props);

        this.state = {

            timeSlots: [],
            datesRemoved: [],
            startTime: "",
            endTime: "",
            firstName: "",
            email: "",
            phone: "",
            pickupDate: "",
            picktime: "",
            disabled: true,
            recipientName: "",
            recipientEmail: "",
            recipientPhone: "",
            comments: "",
            lastDeliveryDate: "",
            resHalls: [],
            deliveryType: "",
            hall: "",
            room: "",
            same: ""
        }

    };

    componentDidMount() {
        fetch(this.props.commonUrl+'getTime.php?revenueCenter=Bakery')
            .then((response) => {
                return response.json();
            }).then(data => {
                this.setState({ timeSlots: data.timeArray })
                this.setState({ datesRemoved: data.datesRemoved })
                this.setState({ startTime: data.startTime })
                this.setState({ endTime: data.endTime })
                this.setState({ lastDeliveryDate: data.lastDeliveryDate })
                this.setState({ resHalls: data.resHall })

            });

    }

    handleCheckOut = (e) => {

        const bodyFormData = new FormData();

        bodyFormData.append('addedItem', JSON.stringify(this.props.orders));
        bodyFormData.append('person', JSON.stringify(this.state));
        bodyFormData.append('total', this.props.total);
        localStorage.clear();

        axios.post(this.props.commonUrl+'paymentShoppingCart.php', bodyFormData)
            .then(function (response) {
                console.log(response);
                window.location.replace("https://apps2.housing.k-state.edu/code/bakery/shoppingRedirect.php?idOrder=" + response.data)
            }).catch(function (error) {
                console.log(error);

            });

    }
    setValues = (e) => {
        this.setState({ [e.target.name]: e.target.value });
        if ([e.target.name] == "same") {
            if (e.target.checked) {
                this.setState({ recipientName: this.state.firstName });
                this.setState({ recipientEmail: this.state.email });
                this.setState({ recipientPhone: this.state.phone });
            } else {
                this.setState({ recipientName: "" });
                this.setState({ recipientEmail: "" });
                this.setState({ recipientPhone: "" });
            }
        }
        if (this.state.deliveryType == "Pickup") {
            this.setState({ room: "" });
            this.setState({ hall: "" });
        } else if (this.state.deliveryType == "Delivery") {
            this.setState({ picktime: "" });
        }
    }
    handleDatePickerChange = (date, dateString) => {
        this.setState({ pickupDate: dateString });
    }


    render() {
        if (this.props.orders.length > 0) {
            const { subTotal } = this.props.location.state
            var totalAmount = subTotal.totalWithTax;
        }
        const mystyle = {
            color: "white",
            width: "250px",
            fontSize: "1.25rem"
        };

        var disabledDates = this.state.datesRemoved
        var lastDeliveryDate = this.state.lastDeliveryDate
        var dateObj = new Date(lastDeliveryDate);
        var momentObj = moment(dateObj);
        lastDeliveryDate = momentObj.format('MM-DD-YYYY');
       // 2021-07-15
        function disabledDate(current) { 
            // Can not select sundays and predfined days
            //return (moment(current).day() === 6 || moment(current).day() === 0 || (current && current < moment().add(2, "days")) || disabledDates.find(date => date === moment(current).format("MM-DD-YYYY") || moment(current).format("MM-DD-YYYY") > lastDeliveryDate))
            return (moment(current).day() === 6 || moment(current).day() === 0 || (current < moment().add(2, "days")) || disabledDates.find(date => date === moment(current).format("MM-DD-YYYY") || moment(current) >moment(dateObj).add(1, "days")))

        }


        var phno = /^[2-9]\d{2}\d{3}\d{4}$/;
        var phone = "";
        var name = /^[a-z\d\-_\s]+$/i;
        var alphName = "";
        if (this.state.phone) {

            if (this.state.phone.match(phno) && (this.state.recipientPhone.match(phno))) {
                phone = true;
            } else {
                phone = false;
            }
        }
        if (this.state.firstName) {

            if (this.state.firstName.match(name) && this.state.recipientName.match(name)) {
                alphName = true;
            } else {
                alphName = false;
            }
        }
        var disable
        if ((this.state.firstName == "") || (this.state.recipientName == "") || !this.state.recipientEmail || !this.state.email || !this.state.phone || this.props.orders.length == 0 ||
            phone == false || alphName == false || (this.state.pickupDate == "") || (this.state.deliveryType == "")) {

            disable = true;
        } else {

            if (this.state.deliveryType == "Delivery") {
                if (this.state.room == "" || this.state.hall == "") {
                    disable = true
                }
            } else if (this.state.deliveryType == "Pickup") {
                if (this.state.picktime == "") {
                    disable = true
                }
            } else {
                disable = false;
            }


        }

        return (
            <div>
                <Navbar isAuthed={true} amount={totalAmount} />
                <div className="container">

                    <br />
                    <span className="error">* </span><label style={{ color: "Black" }}>Please fill this field</label>
                    <div className="checkout">
                        <h5 class="tophead card-panel  purple darken-4" style={mystyle}>My Information</h5>

                        <div class="input-field col s6">
                            <label class="myinfo" style={{ color: "Black" }} for="first_name"><b>Name:</b><span className="error">* </span></label>

                            <input id="firstName" ref="firstName" name="firstName" onChange={this.setValues} defaultValue={this.state.firstName} pattern="[a-zA-Z0-9\s]+" type="text" class="validate" required />
                            <span class="helper-text" data-error="Please avoid special characters" data-success=""></span>
                        </div>
                        <div className="input-field col s6 ">
                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="email"><b>Email:</b><span className="error">* </span> </label>
                            <input className="col-sm-3 form-control" id="email" name="email" type="email" onChange={this.setValues} defaultValue={this.state.email} required />
                        </div>

                        <div className="input-field col s6  " style={{ height: "59px" }}>
                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="phone"><b>Phone:</b><span className="error">* </span> </label>
                            <input className="col-sm-3 form-control" pattern="[0-9]{3}[0-9]{3}[0-9]{4}" name="phone" id="phone" type="tel" class="validate" onChange={this.setValues} required />
                            <span class="helper-text" data-error="Please match the format XXXXXXXXXX" data-success=""></span>
                        </div>

                        <h5 class="tophead card-panel purple darken-4 " style={mystyle} >Recipient Information</h5>
                        <label><input name="same" onChange={this.setValues} value="1" type="checkbox" />
                            <span style={{ color: "Black" }}>Recipeint Info is same as My Information</span></label>

                        <div class={this.state.same == "1" ? "col s6" : "input-field col s6"}>
                            <label class="myinfo" style={{ color: "Black" }} for="recipientEmail"><b>Recipient Name:</b><span className="error">* </span></label>
                            <input id="recipientName" ref="firstName" name="recipientName" onChange={this.setValues} defaultValue={this.state.recipientName} pattern="[a-zA-Z0-9\s]+" type="text" class="validate" required />
                            <span class="helper-text" data-error="Please avoid special characters" data-success=""></span>
                        </div>
                        <div class={this.state.same == "1" ? "col s6" : "input-field col s6"}>
                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="recipientEmail"><b>Recipient Email:</b><span className="error">* </span> </label>
                            <input className="col-sm-3 form-control" id="recipientEmail" name="recipientEmail" type="email" onChange={this.setValues} defaultValue={this.state.recipientEmail} required />
                        </div>

                        <div class={this.state.same == "1" ? "col s6" : "input-field col s6"} >
                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="recipientPhone"><b>Recipient Phone:</b><span className="error">* </span> </label>
                            <input className="col-sm-3 form-control" pattern="[0-9]{3}[0-9]{3}[0-9]{4}" name="recipientPhone" id="recipientPhone" defaultValue={this.state.recipientPhone} type="tel" class="validate" onChange={this.setValues} required />
                            <span class="helper-text" data-error="Please match the format XXXXXXXXXX" data-success=""></span>
                        </div>
                        <div className=" form-inline ">
                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="deliverType" ><b>Select a Pickup Method:</b><span className="error">* </span></label>
                            <label >
                                <input type="radio" class="btn" name="deliveryType" id="Pickup" value="Pickup" onChange={this.setValues} required="" aria-required="true" />
                                <span style={{ color: "Black" }}>Pickup</span></label> &nbsp;
                <label >
                                <input type="radio" class="" name="deliveryType" id="Delivery" value="Delivery" onChange={this.setValues} required="" aria-required="true" />
                                <span style={{ color: "Black" }}>Delivery (Available for Derby Complex (for $5) /Kramer complex,Jardine (for $10))</span>
                            </label>
                        </div>
                        {this.state.deliveryType == "Delivery" ?
                            <div>
                                <div class="materialert danger ">
                                    <div class="material-icons">error_outline</div>
                        Deliveries to Residence Halls will be sent to the Front Desk for the student to pick up.
                        Items will be delivered between 2:00 p.m. and 4:00 p.m. on the specified delivery date at the respective location. Delivery charge will be added to the final total if selected.
                        </div>
                                <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="vehicle"><b>Deliver To</b><span className="error">* </span> </label>

                                <div className="input-field col s6 ">
                                    <select id="hall" name="hall" onChange={this.setValues} defaultValue={this.state.hall}>
                                        <option>Select Hall</option>
                                        {this.state.resHalls.map((halls) => <option value={halls.name}>{halls.name}</option>)}</select>
                                </div>
                                <div className="input-field col s6 ">
                                    <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="allergy"><b>Room#</b> :<span className="error">* </span></label>
                                    <input className="col-sm-3 form-control" id="room" name="room" type="text" onChange={this.setValues} defaultValue={this.state.room} required />

                                </div></div> : ""}

                        <br />
                        <div className="form-inline ">

                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="pickupTime" ><b>{this.state.deliveryType == "Delivery" ? "Delivery Date:" : "Pickup Date:"}</b><span className="error">* </span></label>

                            <div className="input-field col s6 ">
                                <DatePicker onChange={(date, dateString) => this.handleDatePickerChange(date, dateString)}
                                    format="MM-DD-YYYY"
                                    disabledDate={disabledDate}
                                    minDate={moment().format('MM-DD-YYYY')}

                                />
                            </div>

                        </div>
                        {this.state.deliveryType == "Pickup" ?
                            <div>
                                <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="pickupTime" ><b>Pickup Time:</b><span className="error">* </span></label>
                                <div className="input-field col s6 ">
                                    <select id="picktime" name="picktime" onChange={this.setValues} defaultValue={this.state.picktime}>
                                        <option>Select time</option>
                                        {this.state.timeSlots.map((t) => <option value={t}>{t}</option>)}</select>
                                </div></div> : ""}
                        <div className="input-field col s6 ">
                            <label style={{ color: "Black" }} className="col-sm-2 myinfo" htmlFor="allergy"><b>Comments</b> :</label>
                            <input className="col-sm-3 form-control" id="comments" name="comments" type="text" onChange={this.setValues} defaultValue={this.state.comments} required />
                        </div>


                        <br /> <button className="waves-effect waves-light btn " disabled={disable} onClick={() => { this.handleCheckOut(this.props) }} >Proceed</button>


                        <Link to="/cart" className="waves-effect waves-light btn ">Cancel</Link>
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        orders: state.orders,
        total: state.total,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addShipping: () => { dispatch({ type: 'ADD_SHIPPING' }) },
        substractShipping: () => { dispatch({ type: 'SUB_SHIPPING' }) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckOut)
